import { type CSSObject, Stack, styled, Typography } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';
export const TestimonialsSection = styled(Section)(() => ({
  contain: 'paint',
}));
export const StyledStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(16, 0, 20, 0),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(10),
  [theme.breakpoints.down('lg')]: {
    gap: theme.spacing(8),
    padding: theme.spacing(10, 0, 10, 0),
  },
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(6),
    padding: theme.spacing(9, 0, 9, 0),
  },
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(4),
  },
}));
export const StyledTextStack = styled(Stack)(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  position: 'relative',
  flexDirection: 'column',
}));
export const StyledHeaderWrapper = styled(Stack)(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
}));

export const StyledHeader = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
}));

export const StyledHeading = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  fontFamily: 'ClashDisplay',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 800,
  fontSize: `${theme.utils.fluidSize({ minSize: 34, maxSize: 48 })} !important`,
  lineHeight: 1.1,
}));

export const StyledAccentBar = styled('span')(({ theme }) => ({
  display: 'block',
  width: 56,
  height: 4,
  borderRadius: 2,
  background: theme.palette.cyanColors?._0,
}));
